// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBYlPyvl7FzSTX_agR8qoJxQ7ulMvgarvg",
    authDomain: "copy-71bf8.firebaseapp.com",
    projectId: "copy-71bf8",
    storageBucket: "copy-71bf8.firebasestorage.app",
    messagingSenderId: "142774165602",
    appId: "1:142774165602:web:f4e86c6f63960b4352f13b",
    measurementId: "G-4GMFZ5V6LM"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
